import Btn from '@app/lui2/Btn';
import {TruncatedText} from '@app/lui2/text';
import Tooltip from '@app/lui2/Tooltip';
import Luiv3Constants from '@app/lui3/constants';
import FaIcon from '@app/lui3/FaIcon';
import {ReactNode} from 'react';
import styled from 'styled-components';

import AttachmentSelector from './AttachmentSelector';
import {MessageAttachment} from './structs';

interface Props {
  avatar: ReactNode;
  name: string;
  subtitle?: string;
  attachmentIds: string[];
  allAttachments: MessageAttachment[];
  showPinned: boolean;
  pinned: boolean;
  attachmentType: string;
  togglePinned: () => void;
  remove: () => void;
  onAttachmentsChanged: (attachmentIds: string[]) => void;
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.625rem;
  min-width: 0;
  height: 2.5rem;
  padding: 0.625rem;
`;

const LeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.375rem;
  min-width: 0;
  flex: 1;
`;

const RightContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-shrink: 0;
`;

const Name = styled(TruncatedText)`
  color: ${Luiv3Constants.baseColor['gray-1000']};
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  letter-spacing: 0.01em;
`;

const Subtitle = styled.span`
  color: ${Luiv3Constants.baseColor['gray-600']};
`;

const EntityLink = ({
  avatar,
  name,
  subtitle,
  attachmentIds,
  allAttachments,
  pinned,
  attachmentType,
  showPinned,
  togglePinned,
  remove,
  onAttachmentsChanged,
}: Props) => {
  return (
    <Container>
      <LeftContent>
        {avatar}
        <Name>
          {name}
          {subtitle && <Subtitle> ({subtitle})</Subtitle>}
        </Name>
      </LeftContent>
      <RightContent>
        <AttachmentSelector
          attachments={allAttachments}
          selectedAttachmentIds={attachmentIds}
          onAttachmentsChanged={onAttachmentsChanged}
          attachmentType={attachmentType}
        />
        {showPinned && (
          <Tooltip text="Pin in Activity" placement="bottom">
            <Btn
              before={
                <FaIcon
                  icon="thumbtack"
                  faStyle={pinned ? 'solid' : 'regular'}
                />
              }
              size="medium"
              onClick={togglePinned}
              variant="text"
              color={pinned ? 'primary' : 'secondary'}
            />
          </Tooltip>
        )}
        <Btn
          size="medium"
          onClick={remove}
          variant="text"
          before={<FaIcon icon="close" faStyle="solid" />}
        />
      </RightContent>
    </Container>
  );
};

export default EntityLink;
